import type { Predication } from '@/types/Predication'
import { requeteApi } from './apiClient'

/** Prédication telle que renvoyée par l'API (JSON-LD). Le front appelle « id » ce que l'API appelle « slug ». */
export interface PredicationApi {
  slug: string
  titre: string
  resume: string
  predicateur: string
  date: string
  serie?: string | null
  videoId: string
}

export const versPredication = ({ slug, serie, ...p }: PredicationApi): Predication => ({
  ...p,
  id: slug,
  serie: serie ?? undefined,
})

// Champs modifiables (groupe « ecriture » côté back). Le slug n'est jamais envoyé : le serveur le génère.
const versCorps = (p: Predication) => ({
  titre: p.titre,
  resume: p.resume,
  predicateur: p.predicateur,
  date: p.date,
  // Série vidée : null explicite, sinon merge-patch garderait l'ancienne valeur.
  serie: p.serie?.trim() || null,
  videoId: p.videoId,
})

export const creerPredication = async (p: Predication): Promise<Predication> =>
  versPredication(await requeteApi<PredicationApi>('/predications', { method: 'POST', corps: versCorps(p) }))

export const modifierPredication = async (p: Predication): Promise<Predication> =>
  versPredication(
    await requeteApi<PredicationApi>(`/predications/${encodeURIComponent(p.id)}`, { method: 'PATCH', corps: versCorps(p) }),
  )

export const supprimerPredication = async (slug: string): Promise<void> => {
  await requeteApi(`/predications/${encodeURIComponent(slug)}`, { method: 'DELETE' })
}
